<div class="wrapper-lg">
    <app-breadcrumbs [items]="[
                     { url: '/bc-contests', text: 'bcContest_listTitle' },
                 { url: '/bc-contests/' + item?.Id, text: item?.Name }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{item?.Name}}
            <app-bc-contest-status [value]="item?.Status" [active]="item?.IsActive"></app-bc-contest-status>
        </h1>
        <aside>
            <div ngbDropdown *ngIf="item && canEdit">
                <button type="button" class="btn btn-outline" ngbDropdownToggle [disabled]="item?.Completed">
                    {{'bcContest_btnActions' | translate}}
                </button>
                <div ngbDropdownMenu>
                    <button ngbDropdownItem [routerLink]="['/bc-contests', item?.Id, 'edit'] | localize">
                        <i class="fi fi-rs-pencil"></i>
                        {{'edit' | translate}}
                    </button>

                    <button ngbDropdownItem (click)="syncCourses()">
                        <i class="fi fi-rs-list"></i>
                        {{'bcContest_btnSyncCourses' | translate}}
                    </button>

                    <button ngbDropdownItem (click)="syncStudents()">
                        <i class="fi fi-rs-users"></i>
                        {{'bcContest_btnSyncStudents' | translate}}
                    </button>

                    <button ngbDropdownItem (click)="publish()" [disabled]="item.Status != 'Draft'">
                        <i class="fi fi-rs-paper-plane"></i>
                        {{'bcContest_btnPublish' | translate}}
                    </button>

                    <button ngbDropdownItem (click)="apply()" [disabled]="!item.IsOpened">
                        <i class="fi fi-rs-apps-add"></i>
                        {{'bcContest_btnApply' | translate}}
                    </button>

                    <div class="dropdown-divider"></div>

                    <button ngbDropdownItem (click)="calculate()">
                        <i class="fi fi-rs-sort-alt"></i>
                        {{'bcContest_btnCalculate' | translate}}
                    </button>

                    <button ngbDropdownItem (click)="submit()" [disabled]="item.Status != 'Published'">
                        <i class="fi fi-rs-shield-check"></i>
                        {{'bcContest_btnSubmit' | translate}}
                    </button>
                </div>
            </div>
        </aside>
    </header>

    <app-alert *ngIf="item?.Submitted" level="success">{{'bcContest_submitSuccess' | translate | formatString:[item.Submitted | appDate:'datetime']}}</app-alert>
    <app-alert *ngIf="item?.HasSubmitError" level="danger">
        <div>{{'bcContest_submitError' | translate}}</div>
        <div>
            <a href="#" (click)="$event.preventDefault(); openFailedApplications()">{{'bcContest_btnOpenFailedApplications' | translate}}</a>
        </div>
    </app-alert>

    <div class="row">
        <div class="col data-value">
            <label>{{'bcContest_lblOpenedFrom' | translate}}</label>
            <div>
                {{item?.OpenedFrom | appDate:'date'}} <small>{{item?.OpenedFrom | appDate:'time'}}</small>
            </div>
        </div>

        <div class="col data-value">
            <label>{{'bcContest_lblOpenedTo' | translate}}</label>
            <div>
                {{item?.OpenedTo | appDate:'date'}} <small>{{item?.OpenedTo | appDate:'time'}}</small>
            </div>
        </div>

        <div class="col data-value">
            <label>{{'bcContest_lblResultsVisibleFrom' | translate}}</label>
            <div>
                {{item?.ResultsVisibleFrom | appDate:'date'}} <small>{{item?.ResultsVisibleFrom | appDate:'time'}}</small>
            </div>
        </div>

        <div class="col data-value">
            <label>{{'bcContest_lblResultsVisibleTo' | translate}}</label>
            <div>
                {{item?.ResultsVisibleTo | appDate:'date'}} <small>{{item?.ResultsVisibleTo | appDate:'time'}}</small>
            </div>
        </div>
    </div>

    <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="'courses'">
        <li [ngbNavItem]="'courses'">
            <a ngbNavLink>
                {{'bcContest_courses' | translate}}
            </a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-bc-contest-courses *ngIf="item" [contestId]="item.Id" [key]="courseKey"></app-bc-contest-courses>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'students'">
            <a ngbNavLink>
                {{'bcContest_students' | translate}}
            </a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-bc-contest-students *ngIf="item" [contestId]="item.Id" [key]="studentKey"></app-bc-contest-students>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'programs'">
            <a ngbNavLink>
                {{'bcContest_programs' | translate}}
            </a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-bc-contest-programs *ngIf="item" [contestId]="item.Id"></app-bc-contest-programs>
                </div>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>

    <div class="form-actions">
        <button class="btn btn-outline" type="button" [routerLink]="['/bc-contests'] | localize">
            {{'bcContest_btnClose' | translate}}
        </button>
    </div>
</div>
